import { render, staticRenderFns } from "./box-proportion.vue?vue&type=template&id=48ddd034&"
import script from "./box-proportion.vue?vue&type=script&lang=js&"
export * from "./box-proportion.vue?vue&type=script&lang=js&"
import style0 from "./box-proportion.vue?vue&type=style&index=0&id=48ddd034&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports